import { CSSProperties, useEffect, useRef, useState } from "react";
import { BsChevronDown } from "react-icons/bs";

export type findDropdownProps = {
    id: number;
    label: string;
    children: Array<any>;
    styles?: CSSProperties;
};
const FindDropdown = (props: findDropdownProps) => {
    const buttonRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [SearchMailbox, setSearchMailbox] = useState(props.children);
    const [placeholder, RemovePlaceholder] = useState("Search");
    const onOutsideClick = () => {
        setDropdownOpen(false);
        setSearchMailbox(applyLiOnClick());
    };
    useEffect(() => {
        setSearchMailbox(applyLiOnClick);
    }, [props.children]);

    const applyLiOnClick = () => {
        //this method closed the dropdown once a selection has been clicked
        let allChildren = props.children.map((x: any) => {
            let child = { ...x.props };
            child.onClick = () => {
                onOutsideClick();
            };
            return { ...x, props: child };
        });
        return allChildren;
    };
    function onClick(value: string) {
        if (value.length > 2) {
            setSearchMailbox(
                value !== ""
                    ? applyLiOnClick().filter((mb: React.ReactElement) => {
                          const text = mb?.props?.children?.props?.children;
                          return typeof text === "string" && text.toLowerCase().includes(value.toLowerCase());
                      })
                    : applyLiOnClick(),
            );
        } else {
            setSearchMailbox(applyLiOnClick());
        }
    }
    return (
        <div
            className={"g-find-dropdown" + (dropdownOpen ? "-selected" : "")}
            key={props.id}
            ref={buttonRef}
            onMouseLeave={() => onOutsideClick()}
            title={props.label}
            style={props.styles}
        >
            <div
                className="findDropDownWrapper"
                tabIndex={0}
                onClick={() => setDropdownOpen(o => !o)}
            >
                <div className="Col1"> {props.label}</div>
                <div className="Col2">
                    <BsChevronDown style={{ fontSize: "10px", marginLeft: "10px", float: "right" }}> </BsChevronDown>
                </div>
            </div>
            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: "1000",
                        backgroundColor: "white",
                        height: "40px",
                        width: "205px",
                    }}
                >
                    {" "}
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{
                            borderColor: "#888",
                            width: "200px",
                            marginLeft: "2px",
                            marginRight: "5px",
                            fontSize: "13px",
                        }}
                        autoComplete="off"
                        aria-autocomplete="none"
                        list="autocompleteOff"
                        onChange={e => onClick(e.target.value)}
                        placeholder={placeholder}
                        onFocus={e => RemovePlaceholder("")}
                        onMouseOut={e => RemovePlaceholder("Search")}
                    ></input>
                </div>
            )}
            <ul>{SearchMailbox}</ul>
        </div>
    );
};

export default FindDropdown;
